const sidebarStyles = (isCollapsed, isSmallCollapsed) => ({
  sidebarContainer: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: " #119bab !important",
  },
  "& .pro-menu-item.active": {
    backgroundColor: " #119bab!important",
    color: "#0056D2 !important",
    borderLeft: "4px solid #119bab !important",
  },

  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 20px",
    backgroundColor: " #119bab",
    // borderBottom: "1px solid #e0e0e0",
    marginTop: isSmallCollapsed || isCollapsed ? "0px" : "0px",
    zIndex: 1,
    height: "94px",
  },
  logo: {
    width: "80px",
    height: "72px",
    marginLeft: "60px",
    overflowY: "hidden",
    marginTop: "2px",
  },
  toggle: {
    // marginBottom: "10px",
    marginBottom: isSmallCollapsed || isCollapsed ? "10px" : "0px",
  },
  menuContainer: {
    padding: "10px 20px",
    flex: 1,
    overflow: "hidden",
    flexDirection: "column",
    transition: "margin 0.3s ease",
  },
  menuContainerClosed: {
    marginLeft: "10px",
  },
  submenuBox: {
    // backgroundColor: "white",
    marginLeft: "15px",
    paddingLeft: "10px",
    borderLeft: "1px solid #119bab",
  },
  scrollableMenu: {
    backgroundColor: " #119bab",
    height: "calc(100vh - 64px)",
    paddingBottom: "30px",
  },
  menuLinkStyle: {
    textDecoration: "none",
    color: "inherit",
  },
});

export default sidebarStyles;
